export default __webpack_public_path__ + "flotation.png?fc1a6373e6c86850dce73fdbe730b7c5";